import React from 'react';
import { TextField } from '@material-ui/core';

export default ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  const hasError = !!(touched && error);
  const errorElem = <span>{hasError ? error : ''}</span>;
  return (
    <TextField
      multiline
      rows="4"
      error={hasError}
      helperText={errorElem}
      label={label}
      {...input}
      {...custom}
    />
  );
};

